import { PropertyResponseDto } from "@/common/api/datasources/Api";
import { propertyFormSchema } from "@/modules/Properties/schema/propertyFormSchema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as z from "zod";

export const usePropertyForm = (property: PropertyResponseDto | undefined) => {
  const form = useForm<z.infer<typeof propertyFormSchema>>({
    resolver: zodResolver(propertyFormSchema),
    defaultValues: {
      name: "",
      description: "",
      type: "apartment",
      status: "available",
      price: 0,
      currency: "USD",
      address: "",
      city: "",
      state: "",
      stateAbbreviation: "",
      country: "",
      countryAbbreviation: "",
      postalCode: "",
      area: 0,
      rooms: 0,
      bathrooms: 0,
      floor: 0,
      totalFloors: 0,
      yearBuilt: new Date().getFullYear(),
      features: [],
      geoLocation: null,
    },
  });

  useEffect(() => {
    if (property) {
      form.reset({
        name: property.name,
        description: property.description || "",
        type: property.type,
        status: property.status,
        price: property.price,
        currency: "USD",
        address: property.address || "",
        city: property.city || "",
        state: property.state || "",
        stateAbbreviation: property.stateAbbreviation || "",
        country: property.country || "",
        countryAbbreviation: property.countryAbbreviation || "",
        postalCode: property.postalCode || "",
        area: property.area || 0,
        rooms: property.rooms || 0,
        bathrooms: property.bathrooms || 0,
        floor: property.floor || 0,
        totalFloors: property.totalFloors || 0,
        yearBuilt: property.yearBuilt || new Date().getFullYear(),
        features: property.features || [],
        geoLocation: property.geoLocation || null,
      });
    }
  }, [property, form]);

  return form;
}; 